function initFloatingCartBadge() {
    const cartButton = document.getElementById('yt-floating-cart');

    if (!cartButton) {
        return;
    }

    const updateCartBadge = () => {
        const badge = document.getElementById('yt-floating-cart-badge');

        if (!badge) {
            return;
        }

        const quantity = parseInt(badge.textContent, 10) || 0;
        badge.style.display = quantity > 0 ? 'flex' : 'none';
    };

    updateCartBadge();

    new MutationObserver(updateCartBadge).observe(cartButton, {
        childList: true,
        subtree: true,
        characterData: true,
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFloatingCartBadge);
} else {
    initFloatingCartBadge();
}
